module.exports = __webpack_public_path__ + "static/media/13_tn.664c9dd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/13_tn.jpg
// module id = 322
// module chunks = 0